import { Spacing } from '@persona-id/design-tokens';
import { StylesConfig } from 'react-select';

const styles: StylesConfig = {
  control: () => ({
    height: 'auto',
  }),
  valueContainer: (_, { isMulti }) => ({
    height: 'auto',
    minHeight: '30px',
    maxHeight: '80px',
    overflowY: 'auto',
    paddingTop: isMulti ? Spacing[1] : 0,
    paddingBottom: isMulti ? Spacing[1] : 0,
  }),
  multiValueLabel: () => ({
    padding: '2px',
  }),
  option: () => ({
    paddingTop: `${Spacing[2]}`,
    paddingBottom: `${Spacing[2]}`,
  }),
  indicatorsContainer: (_, { isMulti }) =>
    isMulti
      ? {
          display: 'none',
        }
      : { height: '30px', marginRight: Spacing[2] },
};

export default styles;
